/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { iconWrapperStyles } from './styles';
export var IconWrapper = function IconWrapper(props) {
  var breakpoint = props.breakpoint,
    hasTitleBox = props.hasTitleBox;
  return jsx("div", {
    id: "iconWrapper"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: iconWrapperStyles({
      breakpoint: breakpoint,
      hasTitleBox: hasTitleBox
    })
  }, props.children);
};